import { jsx as _jsx } from "react/jsx-runtime";
import { styled, Menu as MUIMenu, } from "@mui/material";
import { convertPxToRem } from "../../util-functions";
const StyledMenu = styled(MUIMenu, {
    shouldForwardProp: (prop) => prop !== "small",
})(({ theme, small }) => ({
    "& .MuiPaper-root": {
        backgroundColor: theme.palette.grey02.main,
        boxShadow: `0 ${convertPxToRem(15)} ${convertPxToRem(37)} rgba(0, 0, 0, 0.18)`,
        borderRadius: convertPxToRem(17),
        height: "auto",
        maxHeight: convertPxToRem(372),
        overflowY: "auto",
        width: small ? convertPxToRem(212) : convertPxToRem(300),
        padding: 0,
    },
}));
export const Menu = ({ anchorEl, children, menuId, MenuListProps, onClose, open, small = false, testId, }) => (_jsx(StyledMenu, Object.assign({ id: menuId, "data-testid": testId, anchorEl: anchorEl, onClose: onClose, open: open, MenuListProps: MenuListProps, small: small, anchorOrigin: {
        vertical: "bottom",
        horizontal: "left",
    }, transformOrigin: {
        vertical: "top",
        horizontal: "left",
    } }, { children: children })));
